<template>
  <div
    :style="{ '--rarityColor': item.rarity_color || '#8E9EBD' }"
    class="thumb"
  >
    <img
      :alt="item.market_hash_name"
      :loading="loading"
      :src="getImageFromWaxpeer(item.market_hash_name, '250:150')"
      class="vl"
      height="90"
      width="144"
    >
  </div>
</template>

<script lang="ts" setup>
import type { ItemsPriceDiffs } from '~/graphql/generated/schema-types';
import { getImageFromWaxpeer } from '~/utils/get-image-url';

defineProps<{
  item: ItemsPriceDiffs
  loading?: 'lazy' | 'eager'
}>();
</script>

<style lang="scss" scoped>
.thumb {
  display: block;
  padding: 2rem 0 0;
  height: 12rem;
  text-align: center;
  position: relative;

  img {
    height: 9rem;
    margin: auto;
    position: relative;
    z-index: 1;
  }

  //&:before {
  //  content: '';
  //  border-radius: 4px;
  //  position: absolute;
  //  left: 50%;
  //  top: 55%;
  //  transform-origin: 0 0;
  //  // width: 7rem;
  //  // padding-bottom: 7rem;
  //  // border: 1px solid rgba(165, 179, 195, 0.05);
  //  // transform: rotate(45deg) translateX(-50%) translateY(-50%);
  //  transform: translateX(-50%) translateY(-50%);
  //  width: 9rem;
  //  padding-bottom: 9rem;
  //  background: url("data:image/svg+xml,%3Csvg viewBox='0 0 97 98' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M94.8076 46.8789L50.4645 2.53566C49.2929 1.36409 47.3934 1.36409 46.2218 2.53566L1.87868 46.8789C0.707107 48.0504 0.707106 49.9499 1.87868 51.1215L46.2218 95.4647C47.3934 96.6363 49.2929 96.6363 50.4645 95.4647L94.8076 51.1215C95.9792 49.9499 95.9792 48.0504 94.8076 46.8789ZM51.1716 1.82856C49.6095 0.266458 47.0768 0.266458 45.5147 1.82856L1.17157 46.1718C-0.390523 47.7339 -0.390525 50.2665 1.17157 51.8286L45.5147 96.1718C47.0768 97.7339 49.6095 97.7339 51.1716 96.1718L95.5147 51.8286C97.0768 50.2665 97.0768 47.7339 95.5147 46.1718L51.1716 1.82856Z' fill='rgba(165, 179, 195, 0.05)'/%3E%3Cpath d='M45.5147 12.8154C47.0768 11.2533 49.6095 11.2533 51.1716 12.8154L84.5275 46.1714C86.0896 47.7335 86.0896 50.2661 84.5275 51.8282L51.1716 85.1843C49.6095 86.7464 47.0768 86.7464 45.5147 85.1843L12.1587 51.8282C10.5967 50.2661 10.5967 47.7335 12.1587 46.1714L45.5147 12.8154Z' fill='rgba(165, 179, 195, 0.05)'/%3E%3C/svg%3E%0A") center center no-repeat;
  //  background-size: contain;
  //}

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 12rem;
    height: 12rem;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: radial-gradient(
            circle,
            color-mix(in srgb, var(--surfaces-on-surface-variable) 84%, transparent) 20%,
            color-mix(in srgb, var(--surfaces-on-surface-variable) 91%, transparent) 40%,
            transparent 70%,
            transparent 100%
    );
  }

  &.red:after {
    background: radial-gradient(
            circle,
            rgba(#e22b2b, 0.16) 20%,
            rgba(#e22b2b, 0.09) 40%,
            transparent 70%,
            transparent 100%
    );
  }

  &.pink:after {
    background: radial-gradient(
            circle,
            rgba(#e22bc5, 0.16) 20%,
            rgba(#e22bc5, 0.09) 40%,
            transparent 70%,
            transparent 100%
    );
  }

  &.violet:after {
    background: radial-gradient(
            circle,
            rgba(#502be2, 0.16) 20%,
            rgba(#502be2, 0.09) 40%,
            transparent 70%,
            transparent 100%
    );
  }

  &.blue:after {
    background: radial-gradient(
            circle,
            rgba(#2b49e2, 0.16) 20%,
            rgba(#2b49e2, 0.09) 40%,
            transparent 70%,
            transparent 100%
    );
  }

  &.lightblue:after {
    background: radial-gradient(
            at center,
            rgba(#2b75e2, 0.16) 20%,
            rgba(#2b75e2, 0.09) 40%,
            transparent 70%,
            transparent 100%
    );
  }
}
</style>

<style scoped>
.thumb {
  --rarityColor: #8E9EBD;
}

.thumb::after {
  background: radial-gradient(
      at center,
      var(--rarityColor) 20%,
      var(--rarityColor) 40%,
      transparent 70%,
      transparent 100%);
  opacity: 0.08;
}
</style>
<!-- //    radial-gradient( //    circle, //    rgba(var(&#45;&#45;rarityColor), 0.16) 20%, //    rgba(var(&#45;&#45;rarityColor), 0.09) 40%, //    transparent 70%, //    transparent 100% //); -->
